import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import Select from "react-select";
import useFetchData from "../../Hooks/useFetchData";
import Api from "../../Hooks/Api";
import { Link } from "react-router-dom";
const Register = (props) => {
  const [inputs, setInputs] = useState({});
  const Institutions = useFetchData("api/DashBoard/1/all/students/register");

  const handleSubmit = (event) => {
    event.preventDefault();
    if(inputs.cPassword !== inputs.Password){
      swal(
        "",
        "Password does not match!",
        "error"
      );
      return;
    }
    if (inputs.CatecoryId && inputs.institutionId) {
      Api.put("api/SelfRegistration/" + inputs.CatecoryId, JSON.stringify(inputs))
      .then((response) => {
        if (response.status == "200") {
          if (response.data.msg === "success") {
            swal("", "Registration complete,You can login", "success");
            return (window.location = "#/");
          } else if (response.data.msg === "Details not found") {
            swal(
              "",
              "Details not found,Refer to school administration",
              "error"
            );
          } else {
            swal("", response.data.msg, "error");
          }
        }

      }, (error) => {
          swal("", "Failed", "error");
      });

    
    } else {
      alert("All fields are required");
    }
  };

  const handleInputChange = (event) => {
    event.persist();
    setInputs((inputs) => ({
      ...inputs,
      [event.target.name]: event.target.value,
    }));
  };
  const handleSelectChange = (UserGroup, actionMeta) => {
    setInputs((inputs) => ({ ...inputs, [actionMeta.name]: UserGroup.value }));
  };
  const InstitutionsOptions = [];
  if (Institutions.response) {
    Institutions.response.map((k, i) => {
      let col = {
        value: k.id,
        label: k.name,
      };
      InstitutionsOptions.push(col);
    });
  }
  let CategoryOptions = [
    {
      value: "1",
      label: "Trainee",
    },
  
  ];
  const styles = {
    control: (base) => ({
      ...base,
      minHeight: "15px",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    clearIndicator: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
    }),
  };
  return (
    <div className="container-fluid">
      <div>
        <br />
        <div class="login login-v2">
          <div id="firstdiv">
            <p
              style={{
                "line-height": 1.5,
                "text-align": "center",
                "font-weight": "bold",
                "margin-bottom": "0px",
              }}
            >
              MINISTRY OF EDUCATION
            </p>
            <br />
            <p
              style={{
                "line-height": 1.5,
                "text-align": "center",
                "font-weight": "bold",
                "margin-bottom": "0px",
              }}
            >
              STATE DEPARTMENT OF VOCATIONAL & TECHNICAL TRAINING
            </p>
            <br />
            <p
              style={{
                "line-height": 1.5,
                "text-align": "center",
                "font-weight": "bold",
                "margin-bottom": "0px",
              }}
            >
              DIRECTORATE OF TVET
            </p>
            <hr />
          </div>
          <div class="login-content">
            <form onSubmit={handleSubmit}>
              <div class="form-group m-b-15">
                <b
                  style={{
                    color: "black",
                    "font-weight": "bold",
                  }}
                >
                  Category
                </b>
                <Select
                  styles={styles}
                  name="CatecoryId"
                  value={CategoryOptions.filter(
                    (option) => option.value === inputs.CatecoryId
                  )}
                  onChange={handleSelectChange}
                  options={CategoryOptions}
                />
              </div>
              <div class="form-group m-b-15">
                <b
                  style={{
                    color: "black",
                    "font-weight": "bold",
                  }}
                >
                  Institution
                </b>
                <Select
                  styles={styles}
                  name="institutionId"
                  value={InstitutionsOptions.filter(
                    (option) => option.value === inputs.institutionId
                  )}
                  onChange={handleSelectChange}
                  options={InstitutionsOptions}
                />
              </div>
              <div class="form-group m-b-15">
                <b
                  style={{
                    color: "black",
                    "font-weight": "bold",
                  }}
                >
                  Registration No
                </b>
                <input
                  type="text"
                  class="form-control "
                  name="Code"
                  onChange={handleInputChange}
                  defaultValue={inputs.Code}
                  required
                />
              </div>
              <div class="form-group m-b-15">
                <b
                  style={{
                    color: "black",
                    "font-weight": "bold",
                  }}
                >
                  Email
                </b>
                <input
                  type="Email"
                  class="form-control "
                  name="Email"
                  onChange={handleInputChange}
                  defaultValue={inputs.Email}
                  required
                />
              </div>
              <div class="form-group m-b-15">
                <b
                  style={{
                    color: "black",
                    "font-weight": "bold",
                  }}
                >
                  Mobile
                </b>
                <input
                  type="text"
                  class="form-control"
                  name="Mobile"
                  onChange={handleInputChange}
                  defaultValue={inputs.Mobile}
                  required
                />
              </div>
              <div class="form-group m-b-15">
                <b
                  style={{
                    color: "black",
                    "font-weight": "bold",
                  }}
                >
                  Password
                </b>
                <input
                  type="password"
                  class="form-control"
                  placeholder="Password"
                  name="Password"
                  onChange={handleInputChange}
                  defaultValue={inputs.Password}
                  required
                />
              </div>
              <div class="form-group m-b-15">
                <b
                  style={{
                    color: "black",
                    "font-weight": "bold",
                  }}
                >
                  Confirm Password
                </b>
                <input
                  type="password"
                  class="form-control"
                  placeholder="Confirm Password"
                  name="cPassword"
                  onChange={handleInputChange}
                  defaultValue={inputs.cPassword}
                  required
                />
              </div>
              <div class="login-buttons">
                <button type="submit" class="btn btn-success btn-block btn-lg">
                  Register
                </button>
              </div>
              <hr />
              <Link to="/Login">
                <b style={{ cursor: "pointer" }} className="text-black">
                  Have account? click here to login now
                </b>
              </Link>
              <hr />
              <p class="text-center text-grey-darker mb-0">
                &copy; Ministry of Education
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
